<template>
  <!-- 🎯 公告弹框 -->
  <div v-if="visible" class="notice-overlay" @click="handleOverlayClick">
    <div class="notice-dialog" @click.stop>
      <!-- 关闭按钮 -->
      <div class="notice-close" @click="closeDialog">
        <i class="el-icon-close"></i>
      </div>
      
      <!-- 公告标题 -->
      <div class="notice-title">{{ title }}</div>
      
      <!-- 公告内容 -->
      <div class="notice-content">
        <div class="notice-text" v-html="formattedContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoticeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 格式化内容，将换行符转换为<br>
    formattedContent() {
      if (!this.content) return '';
      return this.content.replace(/\n/g, '<br>');
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    
    handleOverlayClick() {
      // 点击遮罩层关闭弹框
      this.closeDialog();
    }
  }
}
</script>

<style scoped>
.notice-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--ld-overlay, rgba(17, 17, 17, 0.36));
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.notice-dialog {
  background: var(--ld-bg-card, #fff);
  color: var(--ld-text, #111);
  border-radius: 0.2rem;
  box-shadow: var(--ld-shadow, 0 16px 48px rgba(0, 0, 0, 0.12));
  max-width: 5rem;
  width: 90%;
  max-height: 70vh;
  position: relative;
  overflow: hidden;
}

.notice-close {
  position: absolute;
  top: 0.15rem;
  right: 0.15rem;
  width: 0.24rem;
  height: 0.24rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ld-text-secondary, #888);
  transition: color 0.3s, background 0.3s;
  border-radius: 50%;
}

.notice-close:hover {
  color: var(--ld-text, #111);
  background: var(--ld-bg-active, #f2f2f2);
}

.notice-close i {
  font-size: 0.3rem;
  color: currentColor;
}

.notice-title {
  padding: 0.2rem 0.2rem 0.1rem 0.2rem;
  font-size: 0.35rem;
  font-weight: 600;
  color: var(--ld-text, #111);
  text-align: left;
  margin-bottom: 0;
  padding-right: 0.5rem; /* 为关闭按钮留出空间 */
}

.notice-content {
  padding: 0.2rem;
  max-height: 50vh;
  overflow-y: auto;
  margin-bottom: .2rem;
}

.notice-text {
  font-size: 0.14rem;
  line-height: 1.6;
  color: var(--ld-text, #111);
  word-wrap: break-word;
  white-space: pre-wrap;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .notice-dialog {
    width: 90%;
    max-width: none;
  }
  
  .notice-title {
    font-size: 0.35rem;
    padding: 0.3rem 0.5rem 0.3rem 0.3rem;
    padding-right: 0.45rem;
  }

  .notice-content {
    padding: 0rem 0.3rem 0.3rem 0.3rem;
  }

  .notice-text {
    font-size: 0.18rem;
  }

  .notice-close {
    top: 0.1rem;
    right: 0.1rem;
    width: 0.3rem;
    height: 0.3rem;
  }

  .notice-close i {
    font-size: 0.35rem;
  }
}

/* 滚动条样式 */
.notice-content::-webkit-scrollbar {
  width: 0.04rem;
}

.notice-content::-webkit-scrollbar-track {
  background: var(--ld-bg-muted, #f7f7f7);
  border-radius: 0.02rem;
}

.notice-content::-webkit-scrollbar-thumb {
  background: var(--ld-border-strong, #d0d0d0);
  border-radius: 0.02rem;
}

.notice-content::-webkit-scrollbar-thumb:hover {
  background: var(--ld-text-tertiary, #999);
}
</style>
